<template>
  <b-card v-if="!!option" id="page-company-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }} {{ $t("pages.referrals.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('name'))" label-for="name">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('name'))"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="referred.names"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('name'))"
                    :disabled="!isSaveMode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(label('email'))"
                label-for="email"
                rules="required|email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('email'))"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="referred.email"
                    type="email"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('email'))"
                    :disabled="!isSaveMode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group :label="$t(label('phone'))" label-for="phone">
                <vue-tel-input
                  inputId="phone"
                  name="phone"
                  v-model="referred.phoneNumber"
                  :disabled="!isSaveMode"
                  :mode="'international'"
                  defaultCountry="ve"
                  :disabledFetchingCountry="true"
                  :inputOptions="inputTelOption"
                  @open="onDropdownOpen(true)"
                  @close="onDropdownOpen(false)"
                >
                  <template v-slot:arrow-icon>
                    <span>{{ openTelInput ? "▲" : "▼" }}</span>
                  </template>
                </vue-tel-input>
              </b-form-group>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BAlert,
  BFormSelect,
  BModal,
  BToast,
  BFormRadio,
  BFormRadioGroup,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required, email } from "@validations";
import vSelect from "vue-select";
import { allCompanies } from "@core/api/request/company";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

import { getCatalog } from "@core/api/request/catalogs";

import {
  getReferral,
  createOrEditReferral,
  allReferralsByCompany,
} from "@core/api/request/referrals";

import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

const referred = {
  idReferred: null,
  guidCompany: null,
  names: null,
  phoneNumber: null,
  email: null,
};

export default {
  components: {
    BFormRadio,
    BFormRadioGroup,
    BAlert,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormTextarea,
    BFormSelect,
    BToast,
    BFormInvalidFeedback,
    VueTelInput,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    isSaveMode: true,
    required,
    email,
    option: "",
    referred: Object.assign(referred),
    companies: [],
    roles: [],
    roleSelect: null,
    inputTelOption: {
      placeholder: "Ingrese un número de teléfono",
    },
    openTelInput: false,
  }),
  computed: {},

  created() {
    localize("es");
    this.initialize();
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.referred.guidCompany = guid;
    },
  },

  mounted() {},

  methods: {
    label(field) {
      return `pages.referrals.form.label.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "referrals" }).catch(() => {});
      }

      switch (this.option) {
        case 1:
          this.onCancel();
          this.referred.guidCompany =
            this.$store.state.appConfig.activeCompanyGuid;
          break;
        case 2:
        case 3:
          if (this.$route.params.idReferred === undefined) {
            router.push({ name: "referrals" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          this.getReferred(this.$route.params.idReferred);
          break;
      }
    },

    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          showLoading();

          const idReferred =
            this.option === 1 ? null : this.referred.idReferred;
          console.log("cc", idReferred);
          createOrEditReferral(this.referred, idReferred)
            .then(() => {
              stopLoading();
              this.goBack();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", "Alerta error", error.message);
            });
        }
      });
    },

    getReferred(idReferred) {
      showLoading();
      getReferral(idReferred)
        .then((resp) => {
          const referred = _.get(resp, "data");
          this.referred = Object.assign(this.referred, {
            idReferred: referred.idReferred || null,
            guidCompany: referred.guidCompany || null,
            names: referred.names || null,
            phoneNumber: referred.phoneNumber || null,
            email: referred.email || null,
          });
          stopLoading();
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
          this.alertToast("danger", "Alerta error", error.message);
        });
    },

    loadCompanies() {
      const param = getParams(["page,1", "rows,999"]);
      allCompanies(param)
        .then((resp) => {
          const data = _.get(resp, "data") || [];
          this.companies = _.map(data.items, (company) => {
            return {
              guid: company.guid,
              name: company.name,
            };
          });
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
    onDropdownOpen(isOpen) {
      this.openTelInput = isOpen;
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
    },

    onCancel() {
      Object.assign(this.referred, {
        idReferred: null,
        guidCompany: null,
        names: null,
        phoneNumber: null,
        email: null,
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
